import { Render } from '@9gustin/react-notion-render'
import { MdKeyboardArrowRight } from 'react-icons/md'
import { Link } from 'react-router-dom'

import type { ReactElement } from 'react'

import { useNotionPageQuery } from './queries'

import Modal from '~/components/Modal'
import { ModalBody, ModalFooter, ModalHeader } from '~/components/Modal/Layout'
import MwMLoader from '~/components/MwMLoader'

import '@9gustin/react-notion-render/dist/index.css'

import './styles.scss'

const ChangelogContent = ({
  onClose,
  pageId,
  version,
}: {
  onClose: VoidFunction
  pageId?: string
  version: string
}): ReactElement => {
  const { data: changelog, isLoading } = useNotionPageQuery(pageId)

  return (
    <>
      <ModalHeader>What&apos;s new on v{version}</ModalHeader>
      <ModalBody>
        {isLoading ? (
          <MwMLoader category="item" className="changelog-modal__loader" />
        ) : (
          // @ts-expect-error unknown type
          <Render blocks={changelog?.results} classNames emptyBlocks simpleTitles useStyles />
        )}
      </ModalBody>
      <ModalFooter>
        <div className="changelog-modal-footer-content">
          <div>
            If you have any suggestion use the feedback tab on the right side of the screen
            <MdKeyboardArrowRight size={16} />
          </div>
          <div className="changelog-modal-smiley">
            Made for &#128640;&nbsp;&&nbsp;&#129412;&nbsp;by the Cloud, Web and BigData Team
          </div>
          <div className="changelog-modal-releases">
            <Link onClick={onClose} to="/releases">
              PREVIOUS RELEASES
            </Link>
          </div>
        </div>
      </ModalFooter>
    </>
  )
}

interface Props {
  isOpen: boolean
  onClose: VoidFunction
  pageId?: string
  version: string
}

const ChangeLogModal = ({ isOpen, onClose, pageId, version }: Props): ReactElement => {
  return (
    <Modal className="changelog-modal" isOpen={isOpen} onCloseModal={onClose}>
      <ChangelogContent onClose={onClose} pageId={pageId} version={version} />
    </Modal>
  )
}
export default ChangeLogModal
